<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Thank you for submitting your message to TextbookX.com</h1>
			<p>
				Your message has been forwarded to the correct department and you should receive a response shortly.
			</p>
		</div>

		<base-nav-links home no-back></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './components/BaseNavLinks';

	export default {
		name: "EmailUsSubmitted",

		components: {
			BaseNavLinks,
		},
	}
</script>

<style scoped>

</style>